import { render, staticRenderFns } from "./electronicfence.vue?vue&type=template&id=f07179fe&scoped=true"
import script from "./electronicfence.vue?vue&type=script&lang=js"
export * from "./electronicfence.vue?vue&type=script&lang=js"
import style0 from "./electronicfence.vue?vue&type=style&index=0&id=f07179fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07179fe",
  null
  
)

export default component.exports